var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c(
        "v-layout",
        { attrs: { row: "", "justify-center": "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "", md6: "", lg4: "", "justify-center": "" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "E-mail",
                  type: "email",
                  name: "email",
                  rules: _vm.emailRules,
                  "validate-on-blur": "",
                  placeholder: ""
                },
                model: {
                  value: _vm.email,
                  callback: function($$v) {
                    _vm.email = $$v
                  },
                  expression: "email"
                }
              }),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("v-text-field", {
                attrs: {
                  label: _vm.$t("password"),
                  type: "password",
                  name: "password",
                  placeholder: "",
                  rules: _vm.PasswordRules,
                  "validate-on-blur": ""
                },
                model: {
                  value: _vm.password,
                  callback: function($$v) {
                    _vm.password = $$v
                  },
                  expression: "password"
                }
              }),
              _vm._v(" "),
              _c(
                "v-btn",
                { attrs: { type: "submit" }, on: { click: _vm.login } },
                [_vm._v(_vm._s(_vm.$t("login")))]
              ),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _vm.error
                ? _c("h3", { staticClass: "text-xs-center" }, [
                    _vm._v(_vm._s(_vm.error))
                  ])
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ef68022e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef68022e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = null
// module chunks = 